export default {
  group: {
    rechargeBehavior: '充值行为标签',
    withdrawBehavior: '提现行为标签',
    betBehavior: '投注行为标签',
    gamePreference: '游戏偏好标签',
    lifecycle: '生命周期标签',
    userValue: '用户价值标签',
  },
  field: {
    tagName: '标签',
    hitCount: '用户数',
    hitDescription: '命中说明',
    operation: '操作',
    refreshDays: '标签更新时间',
    lastUpdateTime: '最近更新时间',
    nextUpdateTime: '下次自动更新周期',
    refreshCycle: '间隔周期',
    configSetting: '命中设置',
  },
  action: {
    enable: '开启',
    disable: '关闭',
    setting: '设置',
    save: '保存',
    back: '返回',
    manualUpdate: '手动更新',
    updating: '更新中...',
    confirm: '确定',
  },
  unit: {
    days: '天',
  },
  connector: {
    and: '且 ≤',
  },
  pageTitle: '自动标签设置',
  settingTitle: '设置',
  noAutoTags: '暂无自动标签',
  message: {
    statusUpdateSuccess: '状态更新成功',
    statusUpdateFailed: '状态更新失败',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    configRequired: '所有输入框不允许为空，请完善配置',
    manualUpdateSuccess: '已触发手动更新，后台计算中，请稍后刷新查看',
    manualUpdateFailed: '手动更新失败',
    groupCalculating: '该标签组正在自动更新中，请稍后再试',
  },
  configRule: {
    integerOnly: '仅支持正整数',
    amountUnit: '金额单位与平台充值金额单位保持一致',
    emptyDisabled: '阈值留空时，该币种下对应标签不参与命中',
  },
  tag: {
    FIRST_RECHARGE: '首存用户',
    NO_RECHARGE: '未充值用户',
    RECHARGE_FREQ_LOW: '充值频次低',
    RECHARGE_FREQ_MID: '充值频次中',
    RECHARGE_FREQ_HIGH: '充值频次高',
    RECHARGE_AMT_LOW: '低额充值用户',
    RECHARGE_AMT_MID: '中额充值用户',
    RECHARGE_AMT_HIGH: '高额充值用户',
    NO_WITHDRAW: '未提现用户',
    WITHDRAW_FREQ_LOW: '提现频次低',
    WITHDRAW_FREQ_MID: '提现频次中',
    WITHDRAW_FREQ_HIGH: '提现频次高',
    WITHDRAW_AMT_LOW: '低额提现用户',
    WITHDRAW_AMT_MID: '中额提现用户',
    WITHDRAW_AMT_HIGH: '大额提现用户',
    NO_BET: '未投注用户',
    BET_FREQ_LOW: '投注频次低',
    BET_FREQ_MID: '投注频次中',
    BET_FREQ_HIGH: '投注频次高',
    BET_AMT_LOW: '低额投注用户',
    BET_AMT_MID: '中额投注用户',
    BET_AMT_HIGH: '大额投注用户',
    PREFER_LIVE: '偏好真人游戏',
    PREFER_SLOT: '偏好电子游戏',
    PREFER_SPORT: '偏好体育',
    PREFER_CHESS: '偏好棋牌游戏',
    ACTIVE_RETAINED: '留存活跃用户',
    ACTIVE_NO_DEPOSIT: '活跃未存款用户',
    RETURN_NO_RECHARGE: '回流未充值用户',
    CHURN_RISK: '流失风险用户',
    CHURNED: '流失用户',
    NET_LOSS_HIGH: '高净输用户',
    NET_LOSS_MID: '中净输用户',
    NET_LOSS_LOW: '低净输用户',
    NET_WIN_HIGH: '高净赢用户',
    NET_WIN_MID: '中净赢用户',
    NET_WIN_LOW: '低净赢用户',
  },
  hitDesc: {
    FIRST_RECHARGE: '首次充值 = 1',
    NO_RECHARGE: '累计充值次数 = 0',
    RECHARGE_FREQ_LOW: '累计充值次数 ≤ X',
    RECHARGE_FREQ_MID: '累计充值次数 ≥ X 且 ≤ X',
    RECHARGE_FREQ_HIGH: '累计充值次数 ≥ X',
    RECHARGE_AMT_LOW: '累计充值金额 ≤ X',
    RECHARGE_AMT_MID: '累计充值金额 ≥ X 且 ≤ X',
    RECHARGE_AMT_HIGH: '累计充值金额 ≥ X',
    NO_WITHDRAW: '累计提现次数 = 0',
    WITHDRAW_FREQ_LOW: '累计提现次数 ≤ X',
    WITHDRAW_FREQ_MID: '累计提现次数 ≥ X 且 ≤ X',
    WITHDRAW_FREQ_HIGH: '累计提现次数 ≥ X',
    WITHDRAW_AMT_LOW: '累计提现金额 ≤ X',
    WITHDRAW_AMT_MID: '累计提现金额 ≥ X 且 ≤ X',
    WITHDRAW_AMT_HIGH: '累计提现金额 ≥ X',
    NO_BET: '累计投注次数 = 0',
    BET_FREQ_LOW: '累计投注次数 ≤ X',
    BET_FREQ_MID: '累计投注次数 ≥ X 且 ≤ X',
    BET_FREQ_HIGH: '累计投注次数 ≥ X',
    BET_AMT_LOW: '累计投注金额 ≤ X',
    BET_AMT_MID: '累计投注金额 ≥ X 且 ≤ X',
    BET_AMT_HIGH: '累计投注金额 ≥ X',
    PREFER_LIVE: '真人类投注金额占比 ≥ 50%',
    PREFER_SLOT: '电子类投注金额占比 ≥ 50%',
    PREFER_SPORT: '体育类投注金额占比 ≥ 50%',
    PREFER_CHESS: '棋牌类投注金额占比 ≥ 50%',
    ACTIVE_RETAINED: '≤ 7 天有投注且有存款（非首存）',
    ACTIVE_NO_DEPOSIT: '≤ 7 天有投注且无存款',
    RETURN_NO_RECHARGE: '≤7天内有投注、无存款且最近存款时间 ∈ [15天前, 30天前]',
    CHURN_RISK: '连续7天无登录、无投注且7～15天内有过存款行为',
    CHURNED: '连续15天无登录、无投注且>30天有过存款行为',
    NET_LOSS_HIGH: '净输 ≥ X',
    NET_LOSS_MID: '净输 ≥ X 且 ≤ X',
    NET_LOSS_LOW: '净输 ≤ X',
    NET_WIN_HIGH: '净赢 ≥ X',
    NET_WIN_MID: '净赢 ≥ X 且 ≤ X',
    NET_WIN_LOW: '净赢 ≤ X',
  },
  configLabel: {
    RECHARGE_FREQ_LOW: '累计充值次数 ≤',
    RECHARGE_FREQ_MID: '累计充值次数 ≥',
    RECHARGE_FREQ_HIGH: '累计充值次数 ≥',
    RECHARGE_AMT_LOW: '累计充值金额 ≤',
    RECHARGE_AMT_MID: '累计充值金额 ≥',
    RECHARGE_AMT_HIGH: '累计充值金额 ≥',
    WITHDRAW_FREQ_LOW: '累计提现次数 ≤',
    WITHDRAW_FREQ_MID: '累计提现次数 ≥',
    WITHDRAW_FREQ_HIGH: '累计提现次数 ≥',
    WITHDRAW_AMT_LOW: '累计提现金额 ≤',
    WITHDRAW_AMT_MID: '累计提现金额 ≥',
    WITHDRAW_AMT_HIGH: '累计提现金额 ≥',
    BET_FREQ_LOW: '累计投注次数 ≤',
    BET_FREQ_MID: '累计投注次数 ≥',
    BET_FREQ_HIGH: '累计投注次数 ≥',
    BET_AMT_LOW: '累计投注金额 ≤',
    BET_AMT_MID: '累计投注金额 ≥',
    BET_AMT_HIGH: '累计投注金额 ≥',
    NET_LOSS_HIGH: '净输 ≥',
    NET_LOSS_MID: '净输 ≥',
    NET_LOSS_LOW: '净输 ≤',
    NET_WIN_HIGH: '净赢 ≥',
    NET_WIN_MID: '净赢 ≥',
    NET_WIN_LOW: '净赢 ≤',
  },
}
